import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App.jsx";
import { AppSessionProvider } from "./state/AppSessionContext.jsx";
import "./ui/styles.css";

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <AppSessionProvider>
        <App />
      </AppSessionProvider>
    </BrowserRouter>
  </StrictMode>,
);
